export const paginationLastPage = (
    totalCount: number | undefined,
    perPage: number | null | undefined,
) => {
    return Math.ceil((totalCount || 0) / (perPage || 10)) || 1;
};
